import http from "./httpService";
import { apiUrl } from "../config";

/**
 * Returns just a string, not wrapped in an object with a data field and others like most responses.
 * @returns String
 */
export const getMapApiKey = () => {
  return http.get(`${apiUrl}CdkOrder/GetGoogleMapsAPiKey`);
};

/**
 * returns a promise with that structure, inside the data field of the loaded response object
 * @returns {[
 * {
 * ctposid:number,
 * posname:string,
 * drvid:number,
 * freq: string,
 * fullname:string,
 * }
 * ]}
 */
export const getPositions = () => {
  return http.get(`${apiUrl}CdkOrder/GetPositionsForCdkClient`);
};

export const getGeoCoordinatesForAddress = (address) => {
  // console.log("this ran", address);
  return http.get(`${apiUrl}CdkOrder/GetGeoLocationFromAddress`, {
    params: {
      address: encodeURIComponent(address), //parameters for this endpoint must be URL Encoded
    },
  });
};

export const getMapRouteEP = (requestBody) => {
  return http.post(`${apiUrl}cxt/GetOptimizedRouting`, requestBody);
};

const operationalTypes = {
  create: "Insert",
  update: "Update",
};
/**
 *Creates and assigns stops to drivers. Send over an array of order objects with subobjects indicated address details, position details it was assigned to, order information, and stop type (0 - Pickup, 1 - Delivery )
 * @param {{ operationalType:
 *
 * {
 * address: {streetName:string, cityName: string, state: string, zipCode:string, customerName:string},
 * position: {positionName:string, driverName:string, positionId:number},
 * parcelInformation:{orderId:number, invoiceNumber:string, totalPartCost:number, totalPartSale:number, partsCount:number, sequenceNumber:number},
 * stopType: number
 * }[]}}orderAssignments
 * @returns Promise
 */

export const submitOrdersForPosition = (orderAssignments) => {
  return http.post(`${apiUrl}CdkOrder/PostCdkDedicatedOrder`, {
    operationalType: operationalTypes.create,
    dedicatedRequests: orderAssignments,
  });
};
export const modifyOrdersForPosition = (orderAssignments) => {
  return http.post(`${apiUrl}CdkOrder/RouteStopModification`, {
    operationalType: operationalTypes.update,
    dedicatedRequests: orderAssignments,
  });
};

/**
 *Updates sequence for existing stops. Send over an array of order objects with subobjects indicated address details, position details it was assigned to, order information, and stop type (0 - Pickup, 1 - Delivery )
 * @param {{
 * address: {streetName:string, cityName: string, state: string, zipCode:string, customerName:string},
 * position: {positionName:string, driverName:string, positionId:number},
 * parcelInformation:{orderId:number, invoiceNumber:string, totalPartCost:number, totalPartSale:number, partsCount:number, sequenceNumber:number},
 * stopType: number
 * }[]}orderAssignments
 * @returns Promise
 */

export const updateStopsForPosition = (orderAssignments) => {
  return http.post(`${apiUrl}CdkOrder/PostCdkDedicatedOrder`, {
    operationalType: operationalTypes.update,
    dedicatedRequests: orderAssignments,
  });
};

export const printManifestForPosition = (
  positionId,
  numberOfStops,
  numberOfMiles,
  estimatedCompletionTime
) => {
  // console.log("print manifest test", positionId);
  // console.log("print manifest test", numberOfStops);
  // console.log("print manifest test", numberOfMiles);
  // console.log("print manifest test", estimatedCompletionTime);

  return http.get(`${apiUrl}CdkOrder/GetCdkDedicatedManifest`, {
    params: {
      positionId,
      numberOfStops,
      numberOfMiles,
      estimatedCompletedTime: estimatedCompletionTime,
    },
    responseType: "blob",
  });
};

export const getCDKOrderDetails = (cdkOrderId) => {
  return http.get(`${apiUrl}CdkOrder/GetCdkOrderDetails`, {
    params: { cdkOrderId: cdkOrderId },
  });
};

export const UpdateCdkOrderInformation = (
  cdkOrderId,
  newAddress,
  newCSZ,
  newCustomerName
) => {
  return http.post(`${apiUrl}CdkOrder/UpdateCdkOrderInformation`, {
    CdkOrderId: cdkOrderId,
    Address: newAddress,
    CityStateZip: newCSZ,
    CustomerName: newCustomerName,
  });
};
